module.exports = __webpack_public_path__ + "img/elisheva.1b38c704.png";